export default __webpack_public_path__ + "static/bUvdkdVB-1213116d3c9a75b09d56d4bff46f7c77.svg";